import { t } from 'i18next';
import { isAmericanAddress } from './func';

export const isAnAmericanPostalCode = (postalcode) => {
  if (postalcode) {
    const code = postalcode.trim();
    const onlyNumbersOnPostalCode = /^[0-9]*$/g;
    return onlyNumbersOnPostalCode.test(code);
  }

  return false;
};

export const addressValidation = (values, dispatch, props, fieldName) => {
  const {
    shipperAddress, consigneeAddress, shipperPostalZipCode, consigneePostalZipCode,
  } = values;

  const error = { ...props.asyncErrors, [fieldName]: undefined };
  let hasError = false;

  if (props.isAuthenticated === false && props.form === 'CreateShipmentForm') {
    if (shipperAddress && isAmericanAddress(shipperAddress)) {
      return new Promise(() => {
        const error = { ...props.asyncErrors, shipperAddress: t('NoServiceOutsideCanada') };
        throw error;
      });
    }

    if (consigneeAddress && isAmericanAddress(consigneeAddress)) {
      return new Promise(() => {
        const error = { ...props.asyncErrors, consigneeAddress: t('NoServiceOutsideCanada') };
        throw error;
      });
    }
  }

  if (fieldName && fieldName.includes('Nickname')) {
    const addressFieldName = `${fieldName.split('Nickname')[0]}Address`;
    props.touch(addressFieldName); // turn on error messages
    return props.asyncValidate(values, dispatch, props, addressFieldName); // evaluate whether the address field will fail or not
  }

  // Check if at least one address is from Canada
  if (shipperPostalZipCode && consigneePostalZipCode) {
    const shipperIsAmerican = isAnAmericanPostalCode(shipperPostalZipCode);
    const consigneeIsAmerican = isAnAmericanPostalCode(consigneePostalZipCode);

    if (shipperIsAmerican && consigneeIsAmerican) {
      hasError = true;
      error.shipperAddress = t('OneAddressMustBeCanadian');
      error.consigneeAddress = t('OneAddressMustBeCanadian');
      error.shipperPostalZipCode = t('OnePostalMustBeCanadian');
      error.consigneePostalZipCode = t('OnePostalMustBeCanadian');
    }
  }

  // Check if shipper and consignee addresses are different
  if (shipperAddress && consigneeAddress) {
    if (shipperAddress === consigneeAddress) {
      hasError = true;
      error.shipperAddress = t('NoSameAddress');
      error.consigneeAddress = t('NoSameAddress');
    }
  }

  if (!hasError) {
    error.shipperAddress = undefined;
    error.consigneeAddress = undefined;
    error.shipperPostalZipCode = undefined;
    error.consigneePostalZipCode = undefined;
  }

  return hasError ? new Promise(() => { throw error; }) : Promise.resolve();
};
